/**
 * Checks if an object is empty.
 * @param myEmptyObj The object to check.
 * @returns True if the object is empty, false otherwise.
 */
export function isEmpty(myEmptyObj: object | undefined): boolean {
    if (myEmptyObj === undefined) {
        return true;
    }
    return Object.keys(myEmptyObj).length === 0;
}
